import { useEffect, useState } from "react";
import api from "@/lib/api";
import { LinkedinLogo, AddressBook } from "@phosphor-icons/react";

const STATUS_LABELS = {
  "non_contacté": "Non contacté", "dm_envoyé": "DM envoyé", "répondu_positif": "Réponse +",
  "répondu_négatif": "Réponse −", "silencieux": "Silencieux", "atelier_inscrit": "Atelier inscrit",
  "client": "Client", "perdu": "Perdu",
};

export default function ContactsTab({ cid }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/contacts", { params: { cabinet_id: cid } }).then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false)); }, [cid]);

  return (
    <div className="space-y-4" data-testid="company-contacts-tab">
      <div className="flex items-center gap-2"><AddressBook size={18} className="text-[#0a66c2]" weight="fill" />
        <h3 className="font-head font-bold">Contacts LinkedIn touchés ({rows.length})</h3></div>
      {loading ? <div className="text-sm text-muted-foreground">Chargement…</div>
        : rows.length === 0 ? <div className="text-sm text-muted-foreground">Aucun contact prospecté chez ce cabinet. Ajoutez-les depuis la page « Contacts LinkedIn ».</div>
        : (
          <div className="bg-white border border-border divide-y divide-border">
            {rows.map((c) => (
              <div key={c.id} className="px-4 py-3 flex items-center justify-between" data-testid={`company-contact-${c.id}`}>
                <div>
                  <div className="font-medium flex items-center gap-1.5">{c.full_name}
                    {c.linkedin_url && <a href={c.linkedin_url} target="_blank" rel="noreferrer"><LinkedinLogo size={15} className="text-[#0a66c2]" weight="fill" /></a>}</div>
                  <div className="text-xs text-muted-foreground">{c.headline || c.assignee_name} {c.campaign_tag && `· ${c.campaign_tag}`}</div>
                </div>
                <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-secondary">{STATUS_LABELS[c.status] || c.status}</span>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
